import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const APKExclusionListSettingsView = React.lazy(
  () => import("./APKExclusionList.view")
);

const APKExclusionListSettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <APKExclusionListSettingsView />
  </React.Suspense>
);
export default () => <APKExclusionListSettingsLoadable />;
